angular.module("propagandaManuscriptServiceModule", [
        'propagandaManuscriptViewRequestModule'
    ])
    .factory("propagandaManuscriptService", ['$modal', '$q', function($modal, $q) {
        return {
            viewRequest: function(docid, title) {
            	var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './resourceCenter/propagandaManuscriptControl/service/viewRequest/viewRequest_tpl.html',
                    windowClass: 'propaganda-manuscript-view-request',
                    backdrop: false,
                    controller: 'propagandaManuscriptViewRequestCtrl',
                    resolve: {
                    	docid: function(){
                    		return docid;
                    	},
                        title: function() {
                            return title;
                        }
                    }
                });
                modalInstance.result.then(function(result){
                	defer.resolve();
                }, function(error){
                	defer.reject();
                });
                return defer.promise;
            }
        };
    }]);